import {ReservationLocation} from '@wix/ambassador-table-reservations-v1-reservation-location/types'
import {Reservation} from '@wix/ambassador-table-reservations-v1-reservation/types'

type MessageType = 'email' | 'phone'

export const getMessageType = (reservee): MessageType => {
  if (reservee?.phone) {
    return 'phone'
  }

  if (reservee?.email) {
    return 'email'
  }

  return 'email'
}

export const getCalendarHref = (
  reservationLocation?: ReservationLocation,
  reservation?: Reservation,
) => {
  const dateFrom = reservation?.details?.startDate
    ? new Date(reservation.details.startDate)
        .toISOString()
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\./g, '')
    : undefined

  const dateTo = reservation?.details?.endDate
    ? new Date(reservation.details.endDate)
        ?.toISOString()
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\./g, '')
    : undefined

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${reservationLocation?.location?.name}&dates=${dateFrom}/${dateTo}&location=${reservationLocation?.location?.address?.formattedAddress}&ctz=${reservationLocation?.location?.timeZone}`
}
